import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { StaggerInView, StaggerInViewItem } from "../tools/Animations";
import { HealthIntegrationPreviewCard } from "../health/aimmaNurse/HealthIntegrationPreviewCard";
import { HealthSection } from "../health/HealthSection";
import { HealthSectionHeader } from "../health/HealthSectionHeader";
import { healthAimmaDoctorSectionContentOffset } from "../health/healthLayout";
import {
    getLocalized,
    HealthLang,
    LocalizedString,
} from "../health/healthTypes";
import { educationLocalePath } from "./educationLocalePath";

const educationHealthBridgeGrid =
    "grid w-full min-w-0 grid-cols-1 items-stretch gap-5 text-left lg:grid-cols-3 lg:gap-6 [text-align:left]";

interface EducationHealthBridgeSectionProps {
    data: DataKeys;
}

export function EducationHealthBridgeSection({
    data,
}: EducationHealthBridgeSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const cards = (data.cards as DataKeys[]) ?? [];

    return (
        <HealthSection
            id="health-bridge"
            ariaLabelledBy="health-bridge-title"
            childPage
        >
            <HealthSectionHeader
                eyebrow={getLocalized(data.eyebrow as LocalizedString, hLang)}
                title={getLocalized(data.title as LocalizedString, hLang)}
                titleId="health-bridge-title"
                subtitle={getLocalized(data.body as LocalizedString, hLang)}
                subtitleWide
            />

            <div className={healthAimmaDoctorSectionContentOffset}>
                <StaggerInView
                    className={educationHealthBridgeGrid}
                    stagger={0.06}
                >
                    {cards.map((card) => {
                        const cardId = card.id as string;
                        const comingSoon = Boolean(card.comingSoon);
                        const title = getLocalized(
                            card.title as LocalizedString,
                            hLang
                        );
                        const body = getLocalized(
                            card.body as LocalizedString,
                            hLang
                        );
                        const ctaLabel = getLocalized(
                            card.ctaLabel as LocalizedString,
                            hLang
                        );
                        const href = card.href
                            ? educationLocalePath(card.href as string, hLang)
                            : undefined;

                        return (
                            <StaggerInViewItem
                                key={cardId}
                                direction="bottom"
                                className="h-full"
                            >
                                <HealthIntegrationPreviewCard
                                    cardId={cardId}
                                    groupId="doctor"
                                    title={title}
                                    body={body}
                                    ctaLabel={ctaLabel}
                                    comingSoon={comingSoon}
                                    hLang={hLang}
                                    href={comingSoon ? undefined : href}
                                />
                            </StaggerInViewItem>
                        );
                    })}
                </StaggerInView>
            </div>
        </HealthSection>
    );
}
